import { usePlutoAvailabilityApiQuery } from 'hooks/useQuery/plutoAvailabilityApi';
import { GET_SITE_AVAILABILITIES } from 'pages/Availability/queries';
import { SiteAvailability } from 'pages/Availability/types';

interface UseSiteAvailabilitiesParams {
  siteSourceName: string;
  siteSourceId: string;
  viewDateRange: {
    start: string;
    end: string;
  };
}

export const useSiteAvailabilities = ({
  siteSourceName,
  siteSourceId,
  viewDateRange,
}: UseSiteAvailabilitiesParams) => {
  return usePlutoAvailabilityApiQuery<{
    siteAvailabilities: Array<SiteAvailability>;
  }>(GET_SITE_AVAILABILITIES, {
    skip: !siteSourceId || !siteSourceName,
    fetchPolicy: 'network-only',
    variables: {
      filter: {
        and: [
          { end: { gte: viewDateRange.start } },
          { start: { lte: viewDateRange.end } },
        ],
        site: {
          sourceName: { eq: siteSourceName },
          sourceId: { eq: siteSourceId },
        },
      },
      sorting: [{ field: 'start', direction: 'DESC' }],
    },
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
  });
};
